import React, { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { w3cwebsocket } from "websocket";

import {
  Button,
  Callout,
  Card,
  Menu,
  MenuItem,
  Spinner,
  Switch,
  Tag,
} from "@blueprintjs/core";

import {
  authenticatedGetFetch,
  authenticatedPostFetch,
  getBackendRoute,
} from "../../../utils/AuthenticatedFetch";
import i18n from "../../../i18n";
import { Select } from "@blueprintjs/select";

function RemoteInput(props) {
  const [data, setData] = useState(props);

  useEffect(() => {
    const client = new w3cwebsocket(
      getBackendRoute("WS") +
        `/supervision/remoteinput?id=${props.srv + "_" + props.input_id}`,
      ["Bearer", localStorage.getItem("token")]
    );
    client.onmessage = (message) => {
      try {
        setData(JSON.parse(message.data));
      } catch (e) {
        console.error(e);
        console.error("Error while parsing paxetor" + JSON.stringify(message));
      }
    };
    return () => {
      if (client !== undefined) client.close();
    };
  }, [props.srv, props.input_id]);

  return (
    <Card className="myCard">
      <Tag
        icon={data.active ? "full-circle" : "circle"}
        large={true}
        fill={true}
      >
        {data.label}
      </Tag>
      <div className="flexbox-center">
        {data.active ? data.label_on || "ON" : data.label_off || "OFF"}
      </div>
    </Card>
  );
}

function RemoteOutput(props) {
  const [clickable, setClickable] = useState(true);
  const [data, setData] = useState(props);

  useEffect(() => {
    const client = new w3cwebsocket(
      getBackendRoute("WS") +
        `/supervision/remoteoutput?id=${props.srv + "_" + props.output_id}`,
      ["Bearer", localStorage.getItem("token")]
    );
    client.onmessage = (message) => {
      try {
        setData(JSON.parse(message.data));
      } catch (e) {
        console.error(e);
        console.error("Error while parsing paxstor" + JSON.stringify(message));
      }
    };
    return () => {
      if (client !== undefined) client.close();
    };
  }, [props.srv, props.output_id]);

  const control = () => {
    if (clickable) {
      setClickable(false);
      authenticatedPostFetch("/supervision/remoteoutput/enable", {
        srv: data?.srv,
        id: data?.output_id,
      });
      setTimeout(() => {
        setClickable(true);
      }, /* props.Durestor || */ 1000);
    }
  };

  return (
    <Card className="myCard noselect">
      <Tag
        icon={data?.active ? "full-circle" : "circle"}
        large={true}
        fill={true}
      >
        {data?.label}
      </Tag>
      {data?.pulse ? (
        <div className="flexbox-center">
          <Button
            text={<Trans>pulse</Trans>}
            disabled={!clickable}
            loading={!clickable}
            onClick={() => {
              setClickable(false);
              authenticatedPostFetch("/supervision/remoteoutput/enable", {
                srv: data?.srv,
                id: data?.output_id,
              });
              setTimeout(() => {
                setClickable(true);
              }, /* data?.Durestor || */ 1000);
            }}
          />
        </div>
      ) : (
        <div className="flexbox-center">
          <Tag
            minimal={true}
            interactive={clickable && data?.active}
            onClick={() => {
              if (data?.active) control();
            }}
          >
            {data?.active ? data?.label_off : <b>{data?.label_off}</b>}
          </Tag>
          <Switch
            disabled={!clickable}
            checked={data?.active}
            onChange={control}
          />
          <Tag
            minimal={true}
            interactive={clickable && !data?.active}
            onClick={() => {
              if (!data?.active) control();
            }}
          >
            {data?.active ? <b>{data?.label_on}</b> : data?.label_on}
          </Tag>
        </div>
      )}
    </Card>
  );
}

export default class RemoteIO extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupFilter: props.groupFilter || "",
    };
  }

  componentDidMount() {
    authenticatedGetFetch(
      "/supervision/remoteios" + this.state.groupFilter,
      (ios) => {
        this.setState({
          ios: ios,
        });
      }
    );
  }

  render() {
    if (this.state.ios === undefined)
      return (
        // loading
        <Callout title={<Trans>remote I/O</Trans>} icon="low-voltage-pole">
          <Spinner />
        </Callout>
      );
    else if (
      (this.state.ios.inputs || []).length === 0 &&
      (this.state.ios.outputs || []).length === 0
    )
      return null; // nothing to display
    else
      return (
        <Callout title={<Trans>remote I/O</Trans>} icon="low-voltage-pole">
          <div className="flexbox-left">
            {(this.state.ios.inputs || []).length > 0 && (
              <Callout icon="input" title={<Trans>inputs</Trans>}>
                <div className="flexbox-left">
                  {this.state.ios.inputs.map((i) => (
                    <RemoteInput
                      key={"rei" + i?.input_id + "_" + i?.srv}
                      {...i}
                    />
                  ))}
                </div>
              </Callout>
            )}
            {(this.state.ios.outputs || []).length > 0 && (
              <Callout icon="output" title={<Trans>outputs</Trans>}>
                <div className="flexbox-left">
                  {this.state.ios.outputs.map((i) => (
                    <RemoteOutput
                      key={"reo" + i?.output_id + "_" + i?.srv}
                      {...i}
                    />
                  ))}
                </div>
              </Callout>
            )}
          </div>
        </Callout>
      );
  }
}

export class RemoteIosSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      open: false,
      ios: [],
      unauthorized: false,
    };
  }

  componentDidMount() {
    if (localStorage.getItem("perm_SPV") === "true") {
      authenticatedGetFetch(
        this.props.type === "INPUT"
          ? "/remoteios/inputs"
          : "/remoteios/outputs",
        (response) => {
          this.setState({ loaded: true, ios: response });
        }
      );
    } else {
      this.setState({ unauthorized: true });
    }
  }

  getNotSelectedIOs() {
    if (this.props.valueSelected.findIndex !== undefined)
      return this.state.ios.filter((el) => {
        return this.props.valueSelected?.findIndex((vs) => el.id === vs.id) < 0;
      });
    else return this.state.ios;
  }

  render() {
    if (this.state.unauthorized) {
      return (
        <Callout intent="warning">
          <Trans>you are not allowed to visualize element:</Trans>
          <Trans>remote I/O</Trans>
          <br />
          <Trans></Trans>
          <Trans>
            for any change of your permissions please contact an administrator
          </Trans>
        </Callout>
      );
    } else if (!this.state.loaded) {
      return <Spinner />;
    } else {
      if (this.state.open)
        return (
          <Select
            items={this.getNotSelectedIOs()}
            itemRenderer={(item, { select, modifiers }) => {
              return (
                <MenuItem
                  key={item.id}
                  label={`(${
                    this.props.type === "INPUT" ? "paxetor" : "paxstor"
                  } n°${
                    this.props.type === "INPUT" ? item.input_id : item.output_id
                  }, srv: ${item?.server?.name})`}
                  text={`${item.label}`}
                  onClick={() => {
                    this.props.onSelect(item.id, item);
                    this.setState({ open: false });
                  }}
                  itemListRenderer={({
                    items,
                    itemsParentRef,
                    query,
                    renderItem,
                  }) => {
                    const renderedItems = items
                      .map(renderItem)
                      .filter(
                        (item) =>
                          item != null &&
                          item.props.text != null &&
                          item.props.text
                            .toUpperCase()
                            .includes(query.toUpperCase())
                      );
                    return (
                      <Menu ulRef={itemsParentRef}>
                        <MenuItem disabled={true} />
                        {renderedItems}
                      </Menu>
                    );
                  }}
                />
              );
            }}
            itemListRenderer={({
              items,
              itemsParentRef,
              query,
              renderItem,
            }) => {
              const renderedItems = items
                .map(renderItem)
                .filter(
                  (item) =>
                    item != null &&
                    item.props.text != null &&
                    item.props.text.toUpperCase().includes(query.toUpperCase())
                );
              return (
                <Menu ulRef={itemsParentRef}>
                  <MenuItem disabled={true} />
                  {renderedItems}
                </Menu>
              );
            }}
          >
            <Button
              text={i18n.t("select an I/O to add")}
              rightIcon="double-caret-vertical"
            />
          </Select>
        );
      else
        return (
          <Button
            icon="add"
            text={this.props.label || ""}
            onClick={() => this.setState({ open: true })}
          />
        );
    }
  }
}
